import { render, staticRenderFns } from "./Bounced.vue?vue&type=template&id=5cfadd8b&scoped=true&"
import script from "./Bounced.vue?vue&type=script&lang=js&"
export * from "./Bounced.vue?vue&type=script&lang=js&"
import style0 from "./Bounced.vue?vue&type=style&index=0&id=5cfadd8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfadd8b",
  null
  
)

export default component.exports